"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DiscountEditor_1 = __importDefault(require("./DiscountEditor"));
exports.default = DiscountEditor_1.default;
